import React from 'react';

// Skeleton component for loading states
export const Skeleton = ({ className = '', variant = 'rectangular' }) => {
  const baseClass = 'animate-pulse bg-white/10 rounded';
  
  const variantClasses = {
    rectangular: 'rounded-lg',
    circular: 'rounded-full',
    text: 'rounded h-4',
  };

  return (
    <div className={`${baseClass} ${variantClasses[variant]} ${className}`} />
  );
};

// Skeleton for stat cards on dashboard
export const StatCardSkeleton = () => (
  <div className="glass-panel p-6 animate-fade-in">
    <div className="flex items-center justify-between">
      <div className="space-y-3">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-10 w-16" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton variant="circular" className="w-14 h-14" />
    </div>
  </div>
);

// Skeleton for table rows
export const TableRowSkeleton = () => (
  <tr className="animate-pulse">
    <td className="px-6 py-4"><Skeleton className="h-4 w-24" /></td>
    <td className="px-6 py-4"><Skeleton className="h-6 w-20 rounded-full" /></td>
    <td className="px-6 py-4"><Skeleton className="h-4 w-32" /></td>
    <td className="px-6 py-4"><Skeleton className="h-4 w-16" /></td>
    <td className="px-6 py-4"><Skeleton className="h-5 w-16 rounded-full" /></td>
    <td className="px-6 py-4"><Skeleton className="h-4 w-20" /></td>
    <td className="px-6 py-4"><Skeleton className="h-4 w-12" /></td>
  </tr>
);

// Skeleton for case detail page
export const CaseDetailSkeleton = () => (
  <div className="space-y-6 animate-fade-in">
    {/* Header skeleton */}
    <div className="flex items-center justify-between">
      <div className="space-y-2">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-32" />
      </div>
      <Skeleton className="h-8 w-24 rounded-full" />
    </div>
    
    {/* Info cards skeleton */}
    <div className="grid md:grid-cols-2 gap-6">
      <div className="glass-panel p-6 space-y-4">
        <Skeleton className="h-6 w-40" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
      <div className="glass-panel p-6 space-y-4">
        <Skeleton className="h-6 w-40" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    </div>
  </div>
);

// Skeleton for form fields
export const FormFieldSkeleton = () => (
  <div className="space-y-2 animate-pulse">
    <Skeleton className="h-4 w-24" />
    <Skeleton className="h-12 w-full rounded-xl" />
  </div>
);

export default Skeleton;
